// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"96c814d6","111":"525c1404","147":"0a951121","246":"f8862d10","431":"fde83adb","559":"711e7d3a","936":"0f34fea1","993":"25d9833b"}[chunkId] + ".chunk.js";
};